import licenseModule from '../../license.module';

export default licenseModule.component('licenseManagement', {
    template: require('./licenseManagement.component.html'),
    controller: licenseManagementComponent,
    bindToController: true
});

function licenseManagementComponent(
    asNotifier,
    LicenseManagementService,
    LicenseOverviewService,
    textResources,
    asLoadingMask
) {
    var vm = this;
    vm.$onInit = activate;

    vm.overview = {
        appspaceIdSummary: null,
        instances: null,
        planInfoSummary: null,
        cloudSubscriptionSummary: null
    };

    function activate() {
        asLoadingMask.show();

        LicenseManagementService.getAppspaceIDSummary().then(
            function(data) {
                vm.overview.appspaceIdSummary = data;
            },
            function() {
                console.log(
                    'licenseManagementComponent.getAppspaceIDSummary : Failed to get appspace id summary.'
                );
            }
        );

        LicenseOverviewService.getCloudSubscriptionSummary().then(
            function(data) {
                vm.overview.cloudSubscriptionSummary = data;
                if (
                    data.bandwidthDetail &&
                    data.bandwidthDetail.usage == null
                ) {
                    asNotifier.error(
                        textResources.bandwidthUsageRetrievalFailed
                    );
                }
            },
            function() {
                console.log(
                    'licenseManagementComponent.getCloudSubscriptionSummary : Failed to get cloud subscription summary.'
                );
            }
        );

        LicenseManagementService.getInstances().then(
            function(data) {
                vm.overview.instances = data;
                asLoadingMask.hide();
            },
            function() {
                console.log(
                    'licenseManagementComponent.getInstances : Failed to get instances.'
                );
            }
        );

        LicenseManagementService.getPlanInfoSummary().then(
            function(data) {
                vm.overview.planInfoSummary = data;

                var isPlanActive = !(
                    data.planStatus == 'inactive' ||
                    data.planStatus == 'restricted' ||
                    data.planType == 'legacy'
                );

                // Show register new instance if it is active plan
                // Hide register new instance if it is active plan + no perpetual
                vm.showRegisterNewInstance = data.hasOnPrem
                    ? !(isPlanActive == false && data.hasPerpetual == false)
                    : false;
            },
            function() {
                console.log(
                    'licenseManagementComponent.getPlanInfoSummary : Failed to get plan info summary.'
                );
            }
        );
    }

    vm.changes = function() {
        activate();
    };

    vm.filterByPending = function(instance) {
        if (
            instance.allocationType == 'static' &&
            instance.instanceType == 'on-premise'
        ) {
            return (
                instance.status == 'pending-renewal' ||
                instance.status == 'pending-id-increase' ||
                (instance.status == 'pending-deactivate' &&
                    instance.allocationType == 'static') ||
                instance.status == 'pending-id-decrease' ||
                (instance.status == 'pending-registration' ||
                    (instance.status != 'active' &&
                        instance.status != 'warning' &&
                        instance.status != 'restricted' &&
                        instance.status != 'inactive'))
            );
        }
    };

    vm.filterByInstanceType = function(instance) {
        return instance.instanceType == 'cloud';
    };

    vm.filterByNotPending = function(instance) {
        if (instance.instanceType == 'on-premise') {
            return (
                (instance.status != 'pending-renewal' &&
                    (instance.status != 'pending-deactivate' &&
                        instance.allocationType != 'static') &&
                    instance.status != 'pending-id-increase' &&
                    instance.status != 'pending-id-decrease' &&
                    instance.status != 'pending-registration') ||
                instance.status == 'active' ||
                instance.status == 'warning' ||
                instance.status === undefined ||
                instance.status == 'restricted' ||
                instance.status == 'inactive' ||
                ((instance.status == 'pending-deactivate' ||
                    instance.status == 'pending-renewal') &&
                    instance.allocationType == 'dynamic')
            );
        }
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-management/licenseManagement.component.js